<div class="toast-container-wrapper position-fixed top-0 end-0 p-3">
  @for (toast of toastService.toasts; track toast.id) {
    <ngb-toast
      [class]="toast.type === 'success' ? 'bg-success text-white' : 'bg-danger text-white'"
      [autohide]="true"
      [delay]="4000"
      (hidden)="toastService.remove(toast)"
    >
      <div class="d-flex align-items-center justify-content-between gap-3">
        <span>{{ toast.message }}</span>
        <button
          type="button"
          class="btn-close btn-close-white"
          aria-label="Close"
          (click)="toastService.remove(toast)"
        ></button>
      </div>
    </ngb-toast>
  }
</div>
